import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./SecondaryTopNav.module.css";
import { Link } from "@utrecht/component-library-react/dist/css-module";
import clsx from "clsx";
export const SecondaryTopNav = _ref => {
  let {
    items,
    layoutClassName
  } = _ref;
  return _jsx("div", {
    className: clsx(styles.secondary, layoutClassName && layoutClassName),
    children: _jsx("nav", {
      children: _jsx("ul", {
        className: styles.ul,
        children: items.map((_ref2, idx) => {
          let {
            label,
            icon,
            current,
            handleClick
          } = _ref2;
          return _jsx("li", {
            className: clsx(styles.li, current && styles.current),
            onClick: handleClick,
            children: _jsxs(Link, {
              className: clsx(styles.link, styles.label),
              children: [icon, label]
            })
          }, idx);
        })
      })
    })
  });
};